/**
 * List of options for the Conveyor Type field
 *
 * @namespace tmrConveyorTypes
 * @type {ngConstant}
 */
export const constant = [
  'tmrConveyorTypes',
  {
    TmrImpinjConveyorDto: 'Tmr Impinj Conveyor',
    TimedImpinjConveyorDto: 'Timed Impinj Conveyor',
    TmrZebraConveyorDto: 'Tmr Zebra Conveyor',
    TimedZebraConveyorDto: 'Timed Zebra Conveyor',
  },
]
